var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeconnexion1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 17,
    width: 297,
    height: 495,
    rx: 120,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M489.968 203.203L392.133 105.368C389.161 102.397 385.632 100.041 381.749 98.4332C377.866 96.8258 373.704 95.999 369.502 96C365.299 96.001 361.138 96.8297 357.255 98.4389C353.373 100.048 349.846 102.406 346.875 105.379C340.874 111.382 337.505 119.523 337.507 128.01C337.508 132.213 338.336 136.374 339.946 140.257C341.555 144.139 343.913 147.666 346.885 150.637L419.653 223.405L158 224.003C149.513 224.003 141.374 227.374 135.373 233.375C129.371 239.376 126 247.516 126 256.003C126 264.49 129.371 272.629 135.373 278.63C141.374 284.631 149.513 288.003 158 288.003L420.784 287.405L346.821 361.368C340.818 367.368 337.445 375.508 337.443 383.995C337.441 392.483 340.81 400.624 346.811 406.627C352.811 412.63 360.95 416.003 369.438 416.005C377.925 416.007 386.066 412.638 392.069 406.637L489.904 308.803C503.891 294.794 511.752 275.811 511.764 256.016C511.776 236.22 503.938 217.228 489.968 203.203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeconnexion1);
export default __webpack_public_path__ + "static/media/deconnexion1.b681e00da2b3987a77a4e8ea6e90cef8.svg";
export { ForwardRef as ReactComponent };